<script lang="ts">
  import { defineComponent } from "vue";
  import SectionAuthorizedCredit from '@/generated/sections/SectionAuthorizedCredit.vue';
  import AuthorizedCredit from '@/extend/classes/AuthorizedCredit';

  export default defineComponent({
    extends: SectionAuthorizedCredit,
    components: {},
    methods: {
      isDisplayed(value: string): boolean {
        if (value === 'CONSUMED_CREDIT' || value === 'IN_PROGRESS')
          return false;
        return value !== 'CREDIT_LIMIT_UNTIL' || !this.editAuthorizedCredit.permanent;
      },
      isRequired(value: string): boolean {
        if (value === 'CREDIT_LIMIT_UNTIL')
          return !this.editAuthorizedCredit.permanent;
        return value === 'ETABLISSEMENT_ID' || value === 'CREDIT_LIMIT';
      },
      readOnly(value: string): boolean {
        return value === 'ETABLISSEMENT_ID' && this.authorizedCredit.id > 0;
      },
      sectionSave(): void {
        this.saveLoading = true;
        this.saveFailed = false;
        if (!this.checkFields()) {
          this.saveLoading = false;
          this.saveFailed = true;
          return;
        }

        AuthorizedCredit.save(this.refAuthorizedCredit)
          .then((saved: AuthorizedCredit) => {
            this.refAuthorizedCredit.fromAuthorizedCredit(saved);
            this.createRef(this.refAuthorizedCredit);
            this.$emit('saved', this.refAuthorizedCredit);
            this.$emit('closeDialog');
          })
          .catch(() => {
            this.saveFailed = true;
          })
          .finally(() => {
            this.saveLoading = false;
          });
      },
    },
  })
</script>
